import {DPart} from '../model'

// Action about division, init division

export interface InitDivisionAction {
    type: "INIT_DIVISION";
    initialState: Array<DPart>;
}

export const initDivision = (initialState: Array<DPart>): InitDivisionAction => ({
    type: "INIT_DIVISION",
    initialState,
});

export interface ChangeDivisionAction {
    type: "CHANGE_DIVISION";
    index: number;
}

export const changeDivision = (index: number): ChangeDivisionAction => ({
    type: "CHANGE_DIVISION",
    index,
});

export type DivisionAction = InitDivisionAction | ChangeDivisionAction;


